// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "@atlaskit-internal_refractor-import" + "." + "ef211e78" + ".chunk.js";
};